"use client";
import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "@/app/hooks";
import {initHome, selectLoading} from "@/app/features/home/slice";
import {Outlet} from "react-router-dom";

const HomePage = () => {

  const dispatch = useAppDispatch();
  const loading = useAppSelector(selectLoading);


  useEffect(() => {
    dispatch(initHome(loading));
  }, [loading, dispatch]);

  return (
    <Outlet/>
  );
};

export default HomePage;